import {EventEmitter, Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MediaInternalService {
  openOtherPanel: EventEmitter<any> = new EventEmitter<any>();
  constructor() { }
}
